export * from '@primeuix/themes/aura/dock';
export { default } from '@primeuix/themes/aura/dock';
